import React, { ReactNode, Component } from "react";
import cx from "classnames";
import styles from "./styles.module.sass";
import Close from "../../assets/images/close.svg";

export type FlushDirection = "left" | "right" | "top" | "bottom";

export interface DrawerProps {
  flush?: FlushDirection;
  active: boolean;
  closeHandler: () => void;
  maxWidth?: string;
  children?: ReactNode;
}

class Drawer extends Component<DrawerProps> {
  static defaultProps: Partial<DrawerProps> = {
    flush: "left",
    maxWidth: undefined,
  };

  render() {
    const {
      flush = "left",
      active,
      closeHandler,
      maxWidth,
      children,
    } = this.props;

    // Build global class names instead of CSS modules
    const classes = cx(
      styles.main, 
      styles[flush], 
      {
      [styles.active]: active,
      }
    );

    return (
      <div className={classes} style={maxWidth ? { maxWidth } : undefined}>
        <button
          type="button"
          onClick={closeHandler}
          className={styles.close}
          aria-label="Close Drawer"
        >
          <Close style={{ width: "3rem", height: "3rem" }} />
        </button>
        {children}
      </div>
    );
  }
}

export default Drawer;
